/**
 * Обратная связь (M6).
 *
 * На закрытой бете это самый ценный канал данных: пять пар расскажут о
 * продукте больше, чем любой дашборд. Поэтому кнопка лежит на виду, а не
 * в подвале настроек.
 */

import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { ApiError, api } from '@/shared/api/client'
import type { IconName } from '@/shared/ui/icon-names'

export type FeedbackKind = 'idea' | 'problem' | 'praise'

export const FEEDBACK_LABELS: Record<FeedbackKind, string> = {
  idea: 'Идея',
  problem: 'Проблема',
  praise: 'Спасибо',
}

/**
 * Значок отдельно от подписи: внутри строки скринридер прочитал бы его как
 * часть названия кнопки, а он тут только для скорости узнавания.
 */
export const FEEDBACK_ICONS: Record<FeedbackKind, IconName> = {
  idea: 'feedback-idea',
  problem: 'state-warning',
  praise: 'feedback-praise',
}

export const FEEDBACK_PLACEHOLDERS: Record<FeedbackKind, string> = {
  idea: 'Чего не хватает? Что сделало бы день проще?',
  problem: 'Что пошло не так? Где и в какой момент?',
  praise: 'Что понравилось? Нам правда важно это знать',
}

export interface FeedbackIn {
  kind: FeedbackKind
  text: string
  screen?: string
}

export interface FeedbackOut {
  id: number
  kind: FeedbackKind
}

export function useSendFeedback(
  options?: UseMutationOptions<FeedbackOut, ApiError, FeedbackIn>,
) {
  return useMutation<FeedbackOut, ApiError, FeedbackIn>({
    mutationFn: (payload) => api.post<FeedbackOut>('/feedback', payload),
    ...options,
  })
}
